/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Card_Updated_SuccessInputs */



/**
* | output |
* | --- |
* | "Your payment method has been updated successfully." |
*
* @param {Card_Updated_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const card_updated_success = /** @type {((inputs?: Card_Updated_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Card_Updated_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre mode de paiement a été mis à jour avec succès.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ihre Zahlungsmethode wurde erfolgreich aktualisiert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il tuo metodo di pagamento è stato aggiornato con successo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ваш способ оплаты успешно обновлен.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Su método de pago ha sido actualizado exitosamente.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("您的付款方式已成功更新。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("お支払い方法が正常に更新されました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आपकी भुगतान विधि सफलतापूर्वक अपडेट कर दी गई है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Seu método de pagamento foi atualizado com sucesso.")
	return /** @type {LocalizedString} */ ("Your payment method has been updated successfully.")
});